var render, staticRenderFns
import script from "./Attention.vue?vue&type=script&lang=js&"
export * from "./Attention.vue?vue&type=script&lang=js&"
import style0 from "./Attention.vue?vue&type=style&index=0&id=474ab662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474ab662",
  null
  
)

export default component.exports